import React, {Component} from 'react';
import Btn from "./Btn";

class BtnPrimary extends Component {
    render() {
        const {children} = this.props;

        return (
            <Btn
                {...this.props}
                primary
            >
                {children}
            </Btn>
        );
    };
}

export default BtnPrimary;


// WEBPACK FOOTER //
// ./src/core/admin/components/UI/BtnPrimary.js